/* eslint-disable */
export default {
  loading: 'Caricamento...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
